<template>
  <a-card class="style1">
    <h3 class="pb-2">Card Orders</h3>
    <a-table :loading="isLoading" :columns="columns" :data-source="orderData" size="middle" bordered rowKey="id">
      <div slot="card_design" slot-scope="text, record" class="text-center">
        <img v-if="!empty(record.proof)" :src="record.proof" alt="front" class="mh-200p cursor-pointer" @click="viewImage(record.proof, 'Proof')" style="max-width: 300px" />
        <img v-if="!empty(record.proof_1)" :src="record.proof_1" alt="back" class="mh-200p cursor-pointer" @click="viewImage(record.proof_1, 'Proof')" style="max-width: 300px" />
        <div class="row" v-if="!['Proof Ready', 'Proof Sent'].includes(record.status)" style="margin-top: 8px">
          <div class="col-12 col-sm-6">
            <img :src="getFrontCardUrl(record)" alt="front" class="w-100 my-1 my-sm-0 mr-sm-1 cursor-pointer" @click="viewImage(getFrontCardUrl(record), 'Card Front')" style="max-width: 150px" />
          </div>
          <div class="col-12 col-sm-6">
            <img :src="getBackCardUrl(record)" alt="back" class="w-100 cursor-pointer" @click="viewImage(getBackCardUrl(record), 'Card Back')" style="max-width: 150px" />
          </div>
        </div>
      </div>
      <div slot="order_type" slot-scope="text, record">
        {{ record.order_type === 're_order' ? 'Reorder' : 'New Order' }}
      </div>
      <div slot="shipping_number" slot-scope="text, record">
        {{ getShippingNumber(record) }}
      </div>
      <div slot="created_at" slot-scope="text, record">
        {{ getFormatedDate(record.created_at) }}
      </div>
      <div slot="updated_at" slot-scope="text, record">
        <a-popover placement="bottomLeft" trigger="click">
          <template slot="content">
            <a-list item-layout="horizontal" :data-source="record.card_histories">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta :title="getFormatedDate(item.created_at, 'MM/DD') + `\xa0\xa0\xa0\xa0\xa0\xa0\xa0` + item.status"></a-list-item-meta>
              </a-list-item>
            </a-list>
          </template>
          <a-button type="link">
            {{ getFormatedDate(record.updated_at) }}
          </a-button>
        </a-popover>
      </div>
      <div slot="status" slot-scope="text, record">
        <a-select :default-value="text === 'Proof Ready' ? 'Proof Sent' : text" :showArrow="false" @change="e => doChangeStatus(e, record)" style="min-width: 120px">
          <a-select-option v-for="(ms, index) in orderStatus" :value="ms.value" :key="index">
            {{ ms.text }}
          </a-select-option>
        </a-select>
      </div>
      <div slot="signature" slot-scope="text, record" class="text-center">
        <a :href="record.approval_signature" download="signature.png">
          <a-icon type="download" />
        </a>
      </div>
      <div slot="order_id" slot-scope="text, record" class="text-center">
        <a
          @click="
            isVisibleModal = true;
            card = record;
          "
          style="color: #1c84c6"
        >
          {{ record.id }}
        </a>
      </div>
      <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" style="padding: 8px">
        <a-input
          v-ant-ref="c => (searchInput = c)"
          :placeholder="`Search ${column.title}`"
          :value="selectedKeys[0]"
          style="width: 190px; margin-bottom: 8px; display: block"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm, column.key)"
        />
        <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px" @click="() => handleSearch(selectedKeys, confirm, column.key)">Search</a-button>
        <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">Reset</a-button>
      </div>
      <a-icon slot="filterIcon" slot-scope="filtered" type="search" :style="{ color: filtered ? '#108ee9' : undefined }" />
    </a-table>
    <CoolLightBox :items="items" :index="index" @close="index = null" :disable-zoom="true" :close-on-click-outside-mobile="true" />

    <a-modal
      v-model="isVisibleTrackingCode"
      title="Add tracking code"
      centered
      style="width: 100%; max-width: 80%"
      :okText="$t('button.submit')"
      @cancel="doCancelTracking"
      @ok="doSubmitTracking"
      :ok-button-props="{ props: { disabled: isLoadingTrackingCode } }"
      :cancel-button-props="{ props: { disabled: isLoadingTrackingCode } }"
      :closable="false"
    >
      <a-spin :tip="`Loading ...`" :spinning="isLoadingTrackingCode" size="large">
        <div class="spin-content">
          <input-tracking-code ref="trackingCode" @onLoading="isLoadingTrackingCode = $event" />
        </div>
      </a-spin>
    </a-modal>
    <a-modal
      v-model="isVisibleModalProof"
      title="Upload a proof image of the design"
      centered
      style="width: 100%; max-width: 80%"
      :okText="$t('button.upload')"
      @cancel="doCancelUpload"
      @ok="doUpload"
      :ok-button-props="{ props: { disabled: isUploading } }"
      :cancel-button-props="{ props: { disabled: isUploading } }"
      :closable="false"
    >
      <a-spin :tip="`Loading ${uploadState}% ...`" :spinning="isUploading" size="large">
        <div class="spin-content">
          <upload-proof ref="uploadProof" @onLoading="uploadState = $event" />
        </div>
      </a-spin>
    </a-modal>

    <a-modal v-model="isVisibleModal" title="Card Order Detail" centered :footer="null" :destroyOnClose="true" :closable="true" :maskClosable="true" style="width: 100%; max-width: 80%">
      <div class="card-item-detail">
        <div style="display: flex; justify-content: space-between; align-items: center">
          <div v-if="!empty(card.church_logo)">
            <span class="mr-2">Logo: </span>
            <img :src="card.church_logo" alt="Logo" style="max-width: 100px" />
          </div>
          <div v-if="!empty(card.qrcode_url)" class="text-center">
            <qrcode-vue :value="card.qrcode_url" :size="150" render-as="canvas" :margin="16" level="H" class="qr-code" ref="qrcode" />
            <a-button @click="downloadQrCode()" type="dashed" size="small" style="margin-top: 2px">Download</a-button>
          </div>
        </div>
        <div v-if="!empty(card.proof)" class="my-1">
          <span class="mr-2">Proof: </span>
          <img :src="card.proof" alt="proof" class="mh-200p" />
        </div>
        <div v-if="!empty(card.proof_1)" class="my-1">
          <span class="mr-2">Proof Back: </span>
          <img :src="card.proof_1" alt="proof back" class="mh-200p" />
        </div>
        <div v-if="!empty(card.other_file)">
          <span class="mr-2">Other file: </span>
          <a :href="card.other_file" target="_blank" rel="noopener noreferrer">{{ card.other_file }}</a>
        </div>
        <div v-if="!empty(card.pastors_name)">
          <span class="mr-2">Order ID: </span>
          <span>{{ card.id }}</span>
        </div>
        <div v-if="!empty(card.pastors_name)">
          <span class="mr-2">Order Type: </span>
          <span>{{ card.order_type === 're_order' ? 'Reorder' : 'New Order' }}</span>
        </div>
        <div v-if="!empty(card.pastors_name)">
          <span class="mr-2">Pastors Name: </span>
          <span>{{ card.pastors_name }}</span>
        </div>
        <div v-if="!empty(card.church_name)">
          <span class="mr-2">Church Name: </span>
          <span>{{ card.church_name }}</span>
        </div>
        <!-- <div v-if="!empty(card.church_email)">
          <span class="mr-2">Church Email: </span>
          <span>{{ card.church_email }}</span>
        </div> -->
        <div v-if="!empty(card.church_phone)">
          <span class="mr-2">Church Phone: </span>
          <span>{{ card.church_phone }}</span>
        </div>
        <div v-if="!empty(card.website)">
          <span class="mr-2">Website: </span>
          <a :href="card.website" target="_blank" rel="noopener noreferrer">{{ card.website }}</a>
        </div>
        <div v-if="!empty(card.service_times)">
          <span class="mr-2">Service Times: </span>
          <span>{{ card.service_times }}</span>
        </div>
        <div v-if="!empty(card.social_media)">
          <span class="mr-2">Social Media: </span>
          <span>{{ card.social_media }}</span>
        </div>
        <div v-if="!empty(card.proofs_email)">
          <span class="mr-2">Proofs Email: </span>
          <span>{{ card.proofs_email }}</span>
        </div>
        <div v-if="!empty(card.notes)">
          <span class="mr-2">Notes: </span>
          <span>{{ card.notes }}</span>
        </div>
        <div v-if="!empty(card.amount)">
          <span class="mr-2">Cards Included: </span>
          <span>{{ separateNumber(card.amount) }}</span>
        </div>
        <div class="border-bottom border-info w-100 my-1" />
        <span class="mr-2">Card Address: {{ getCardAddress }}</span>
        <span class="mr-2">Shipping Address: {{ getShippingAddress }}</span>
      </div>
    </a-modal>
  </a-card>
</template>
<script>
/* eslint-disable */
import { slugData, empty, separateNumber } from '@/utils';
import { includes, get, find, toInteger, groupBy } from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import AdminService from '@/services/AdminService';
import CardOrderService from '@/services/CardOrderService';
import UploadProof from './uploadProof';
import InputTrackingCode from './inputTrackingCode';

export default {
  components: {
    UploadProof,
    InputTrackingCode,
    QrcodeVue,
  },
  data() {
    const orderStatus = [
      { text: 'New Order', value: 'New' },
      { text: 'Design Phase', value: 'Design Phase' },
      { text: 'Proof Sent', value: 'Proof Sent' },
      { text: 'Approved', value: 'Approved' },
      { text: 'Printing', value: 'Printing' },
      { text: 'Shipped', value: 'Shipped' },
      { text: 'Cancel', value: 'Cancel' },
    ];
    return {
      form: this.$form.createForm(this),
      orders: [],
      searching: '',
      error: '',
      isLoading: true,
      orderData: [],
      orderStatus,
      index: null,
      card: {},
      isVisibleModalProof: false,
      isVisibleTrackingCode: false,
      isLoadingTrackingCode: false,
      isVisibleModal: false,
      uploadState: 1,
      items: [],
      pageType: '',
    };
  },
  watch: {
    orders: {
      async handler(val) {
        this.orderData = val;
      },
      immediate: true,
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      await this.doInitData();
      // const resp = await CardOrderService.doGetCardDesigned('church');
    } catch (error) {
      console.error({ error });
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    ...mapGetters(['user', 'shipper']),
    isUploading() {
      return this.uploadState <= 100 && this.uploadState !== 1;
    },
    columns() {
      const list = [
        {
          title: 'Order ID',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: {
            customRender: 'order_id',
          },
        },
        {
          title: 'Church Name',
          dataIndex: 'church_name',
          key: 'church_name',
        },
        {
          title: 'Proofs Email',
          dataIndex: 'proofs_email',
          key: 'proofs_email',
        },
        {
          title: 'Card Design',
          dataIndex: 'card_design',
          key: 'card_design',
          scopedSlots: {
            customRender: 'card_design',
          },
        },
        {
          title: 'Shipping Number',
          dataIndex: 'shipping_number',
          key: 'shipping_number',
          scopedSlots: {
            customRender: 'shipping_number',
          },
        },
        {
          title: 'Count',
          dataIndex: 'amount',
          key: 'amount',
        },
        // {
        //   title: 'Type',
        //   dataIndex: 'type',
        //   key: 'type',
        //   scopedSlots: {
        //     customRender: 'order_type',
        //   },
        // },
        {
          title: 'Old Order',
          dataIndex: 'old_id',
          key: 'old_id',
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          filters: this.orderStatus,
          onFilter: (value, record) => includes(record.status, value),
          scopedSlots: {
            customRender: 'status',
          },
        },
        {
          title: 'Sign',
          dataIndex: 'signature',
          key: 'signature',
          scopedSlots: {
            customRender: 'signature',
          },
        },
        {
          title: 'Created at',
          dataIndex: 'created_at',
          key: 'created_at',
          sorter: (a, b) => a.created_at > b.created_at,
          scopedSlots: {
            customRender: 'created_at',
          },
        },
        {
          title: 'Updated at',
          dataIndex: 'updated_at',
          key: 'updated_at',
          sorter: (a, b) => a.updated_at > b.updated_at,
          scopedSlots: {
            customRender: 'updated_at',
          },
        },
      ].map(item => {
        if (!['action', 'card_design', 'status', 'created_at', 'updated_at'].includes(item.key)) {
          return {
            ...item,
            scopedSlots: {
              ...item.scopedSlots,
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
            },
            onFilter: (value, record) => {
              let rr = record[this.searchedColumn];
              const isInclude = rr && includes(slugData(rr), slugData(value));

              /*if (this.searchedColumn === 'church_email') {
                const proofsEmail = record['proofs_email'];
                return isInclude || (proofsEmail && includes(slugData(proofsEmail), slugData(value)));
              } else */ if (this.searchedColumn === 'shipping_number') {
                rr = record.tracking;
                return rr && includes(slugData(rr), slugData(value));
              } else {
                return isInclude;
              }
            },
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus();
                }, 0);
              }
            },
          };
        }
        return item;
      });

      switch (this.$route.name) {
        case 'AdminCardOrders':
          this.pageType = 'all';
          this.doGetAllCard();
          return list.filter(c => !['shipping_number', 'created_at'].includes(c.key));

        case 'AdminCardOrderNew':
          this.pageType = 'new';
          this.doGetAllCard();
          return list.filter(c => !['shipping_number', 'old_id', 'signature', 'updated_at'].includes(c.key));

        case 'AdminCardOrderHistory':
          this.pageType = 'history';
          this.doGetAllCard();
          return list.filter(c => !['created_at'].includes(c.key));
      }
    },
    getCardAddress() {
      let address = '';
      if (!empty(this.card.card_address)) {
        address += `${this.card.card_address} - `;
      }
      if (!empty(this.card.card_address2)) {
        address += `${this.card.card_address2} - `;
      }
      if (!empty(this.card.card_city)) {
        address += `${this.card.card_city} - `;
      }
      if (!empty(this.card.card_state)) {
        address += `${this.card.card_state} - `;
      }
      if (!empty(this.card.card_zipcode)) {
        address += `${this.card.card_zipcode}`;
      }
      return address;
    },
    getShippingAddress() {
      let address = '';
      if (!empty(this.card.shipping_address)) {
        address += `${this.card.shipping_address} - `;
      }
      if (!empty(this.card.shipping_address2)) {
        address += `${this.card.shipping_address2} - `;
      }
      if (!empty(this.card.shipping_city)) {
        address += `${this.card.shipping_city} - `;
      }
      if (!empty(this.card.shipping_state)) {
        address += `${this.card.shipping_state} - `;
      }
      if (!empty(this.card.shipping_zipcode)) {
        address += `${this.card.shipping_zipcode}`;
      }
      return address;
    },
  },
  methods: {
    empty,
    separateNumber,
    getFormatedDate(date, format) {
      return moment(new Date(date || Date.now())).format(format || 'MM/DD/YYYY');
    },
    getBackCardUrl(record) {
      return get(
        find(get(this.cardsSources, 'back'), item => item.id === toInteger(record.card_back)),
        'url',
      );
    },
    getFrontCardUrl(record) {
      return get(
        find(get(this.cardsSources, 'front'), item => item.id === toInteger(record.card_front)),
        'url',
      );
    },
    getShippingNumber(record) {
      return `${record.shipper} - ${record.tracking}`;
    },
    async doInitData() {
      try {
        const resp = await CardOrderService.doGetCardDesigned('church');
        this.cardsSources = {
          ...groupBy(resp, 'cardtype'),
        };
      } catch (error) {
        console.error({ error });
      }
    },
    async doGetAllCard() {
      this.orders = [];
      this.isLoading = true;
      try {
        if (this.pageType === 'all') {
          this.orders = await AdminService.cardOrder().getOrdersAll();
        } else if (this.pageType === 'new') {
          this.orders = await AdminService.cardOrder().getOrdersNew();
        } else if (this.pageType === 'history') {
          this.orders = await AdminService.cardOrder().getOrdersHistory();
        }
      } catch (e) {
      } finally {
        this.isLoading = false;
      }
    },
    async doChangeStatus(value, record) {
      record.status = value;
      this.card = record;

      try {
        if (value === 'Proof Sent') {
          this.isVisibleModalProof = true;
        } else if (value === 'Shipped') {
          this.isVisibleTrackingCode = true;
        } else {
          this.isLoading = true;
          await this.doUpdateStatus(value);
        }
      } catch (error) {
        console.log({ error });
      } finally {
        this.isLoading = false;
      }
    },
    doCancelUpload() {
      console.log('cancel');
    },
    doCancelTracking() {
      console.log('doCancelTracking');
    },
    doSubmitTracking() {
      this.$refs.trackingCode.handleSubmit(async (error, value) => {
        try {
          if (!error) {
            this.isLoadingTrackingCode = true;
            const respUpdateTracking = await AdminService.cardOrder(this.user.userId).doUpdateTracking(this.card.id, value);
            console.log({ respUpdateTracking });
            await this.doUpdateStatus('Shipped');
            this.isVisibleTrackingCode = false;
          }
        } catch (error) {
          console.log({ error });
        } finally {
          this.isLoadingTrackingCode = false;
        }
      });
    },
    async doUpdateStatus(status) {
      await AdminService.cardOrder(this.user.userId).updateStatus(this.card.id, status);

      this.$notification['success']({
        message: status,
        description: "You have successfully updated status's order card!",
      });

      await this.doGetAllCard();
    },
    async doUpload() {
      try {
        const proofUrls = await this.$refs.uploadProof.submit();
        const respUpdateProof = await AdminService.cardOrder(this.user.userId).uploadProof(this.card.id, proofUrls);
        console.log({ respUpdateProof });
        await this.doUpdateStatus('Proof Sent');
        this.uploadState = 1;
        this.isVisibleModalProof = false;
      } catch (error) {
        console.log({ error });
      }
    },
    handleReset(clearFilters) {
      clearFilters();
    },
    handleSearch(selectedKeys, confirm, key) {
      confirm();
      this.searchedColumn = key;
    },
    viewImage(url, title) {
      this.items = [
        {
          src: url,
          title: title,
        },
      ];
      this.index = 0;
    },
    downloadQrCode() {
      const ref = this.$refs.qrcode;
      const canvas = ref.$el.querySelector('canvas');
      const a = document.createElement('a');
      a.setAttribute('download', `${new URL(ref.value).pathname.replace('/', '_')}.png`);
      a.setAttribute('href', canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'));
      a.style.display = 'none';
      a.click();
      a.remove();
    },
  },
};
</script>
<style lang="scss">
.cool-lightbox .cool-lightbox__slide .cool-lightbox__slide__img {
  width: auto;
  max-width: 480px;
}

.ant-popover-content {
  min-width: 200px;
}
</style>
